export const SET_PRIMARY_COLOR = 'SET_PRIMARY_COLOR';
export const SET_SECONDARY_COLOR = 'SET_SECONDARY_COLOR';
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const SET_UI_THEME = 'SET_UI_THEME';
export const USER_SUBSCRIPTION = 'USER_SUBSCRIPTION';
export const SYSTEM_NOTIFICATIONS = 'SYSTEM_NOTIFICATIONS';



